<template>
  <main id="js-page-content" role="main" class="page-content">
    <div class="row">
      <div class="subheader col-6">
        <h1 class="subheader-title">売上先マスタ編集</h1>
      </div>
      <!-- Right content on content header A nice area to add graphs or buttons -->
      <div class="subheader-block ml-auto demo">
        <button
          type="button"
          @click="add()"
          v-if="showFlags.btn_salesdestinationEditCtrl_10002 && !isEditMode"
          :disabled="btnDisable"
          class="btn btn-primary waves-effect waves-themed"
        >
          <span class="fal fa-check mr-1"></span>追加
        </button>
        <button
          type="button"
          @click="upd(false)"
          v-if="showFlags.btn_salesdestinationEditCtrl_10002 && isEditMode"
          :disabled="btnDisable"
          class="btn btn-primary waves-effect waves-themed"
        >
          <span class="fal fa-check mr-1"></span>登録
        </button>
        <button
          type="button"
          @click="delConf()"
          v-if="showFlags.btn_salesdestinationEditCtrl_10002 && isEditMode"
          :disabled="btnDisable"
          class="btn btn-danger waves-effect waves-themed"
        >
          <span class="fal fa-times mr-1"></span>削除
        </button>
        <button
          :disabled="btnDisable"
          type="button"
          class="btn btn-secondary waves-effect waves-themed"
          @click="$router.push('/salesDestinationList')"
        >
          <span class="fal fa-reply mr-1"></span>戻る
        </button>
      </div>
    </div>
    <!-- Your main content goes below here: -->
    <div class="row">
      <div class="col-xl-12">
        <div id="panel-1" class="panel">
          <div class="panel-hdr">
            <h2>編集項目</h2>
            <div class="panel-toolbar">
              <button
                class="btn btn-panel"
                data-action="panel-collapse"
                data-toggle="tooltip"
                data-offset="0,10"
                data-original-title="Collapse"
              ></button>
              <button
                class="btn btn-panel"
                data-action="panel-fullscreen"
                data-toggle="tooltip"
                data-offset="0,10"
                data-original-title="Fullscreen"
              ></button>
            </div>
          </div>
          <div class="panel-container show" id="panel-editers">
            <div class="loader">
              <i class="fal fa-spinner-third fa-spin-4x fs-xxl"></i>
            </div>
            <div class="panel-content contents">
              <div class="row">
                <div class="col-md-1 contTitle">売上先コード</div>
                <div class="col-md-5 contCnt">
                  <input
                    type="text"
                    name="txtClientCd"
                    class="form-control form-control-sm"
                    disabled
                    v-model="delegate.c_client_id"
                  />
                </div>
              </div>
              <!-------------------->
              <div class="row">
                <div class="col-md-1 contTitle">売上先名１</div>
                <div class="col-md-5 contCnt">
                  <input
                    type="text"
                    name="txtClientNm1"
                    class="form-control form-control-sm"
                    maxlength="200"
                    v-model="delegate.c_client_name"
                  />
                  <div
                    v-if="errors?.path === 'clientName'"
                    class="error-message4vali"
                  >
                    {{ errors.message }}
                  </div>
                </div>
              </div>
              <!-------------------->
              <div class="row">
                <div class="col-md-1 contTitle">売上先名２</div>
                <div class="col-md-5 contCnt">
                  <input
                    type="text"
                    name="txtClientNm2"
                    class="form-control form-control-sm"
                    maxlength="200"
                    v-model="delegate.c_client_name2"
                  />
                </div>
              </div>
              <!-------------------->
              <div class="row">
                <div class="col-md-1 contTitle">売上先名３</div>
                <div class="col-md-5 contCnt">
                  <input
                    type="text"
                    name="txtClientNm3"
                    class="form-control form-control-sm"
                    maxlength="200"
                    v-model="delegate.c_client_name3"
                  />
                </div>
              </div>
              <!-------------------->
              <div class="row">
                <div class="col-md-1 contTitle">ふりがな</div>
                <div class="col-md-5 contCnt">
                  <input
                    type="text"
                    name="txtFurigana"
                    class="form-control form-control-sm"
                    maxlength="200"
                    v-model="delegate.c_client_name_pt"
                  />
                  <div
                    v-if="errors?.path === 'clientNamePt'"
                    class="error-message4vali"
                  >
                    {{ errors.message }}
                  </div>
                </div>
              </div>
              <!-------------------->
              <div class="row">
                <div class="col-md-1 contTitle">会社種類</div>
                <div class="col-md-5 contCnt">
                  <vSelect
                    :options="op4CompanyType"
                    v-model="delegate.c_client_company_type"
                    :reduce="(label:any) => label.code"
                  ></vSelect>
                </div>
              </div>
              <!-------------------->
              <div class="row">
                <div class="col-md-1 contTitle">表記</div>
                <div class="col-md-5 contCnt">
                  <vSelect
                    :options="op4SignagePosi"
                    v-model="delegate.c_client_flag_company_signage_posi"
                    :reduce="(label:any) => label.code"
                  ></vSelect>
                </div>
              </div>
              <!-------------------->
              <div class="row">
                <div class="col-md-1 contTitle">管轄拠点</div>
                <div class="col-md-5 contCnt">
                  <vSelect
                    :options="delegate4list.items4Branch"
                    v-model="delegate.c_branch_id"
                    :reduce="(label:any) => label.c_branch_id"
                    label="c_branch_name"
                  ></vSelect>
                  <div
                    v-if="errors?.path === 'branchId'"
                    class="error-message4vali"
                  >
                    {{ errors.message }}
                  </div>
                </div>
              </div>
              <!-------------------->
              <!-- <div class="row">
                <div class="col-md-1 contTitle">営業担当</div>
                <div class="col-md-5 contCnt">
                  <vSelect
                    :options="op4Staff"
                    :reduce="(label:any) => label.code"
                  ></vSelect>
                </div>
              </div> -->
              <!-------------------->
              <div class="row">
                <div class="col-md-1 contTitle">TEL</div>
                <div class="col-md-5 contCnt">
                  <input
                    type="text"
                    name="txtTel"
                    class="form-control form-control-sm"
                    maxlength="13"
                    v-model="delegate.c_client_tel"
                  />
                </div>
              </div>
              <!-------------------->
              <div class="row">
                <div class="col-md-1 contTitle">FAX</div>
                <div class="col-md-5 contCnt">
                  <input
                    type="text"
                    name="txtFax"
                    class="form-control form-control-sm"
                    maxlength="13"
                    v-model="delegate.c_client_fax"
                  />
                </div>
              </div>
              <!-------------------->
              <div class="row">
                <div class="col-md-1 contTitle">郵便番号</div>
                <div class="col-md-5 contCnt">
                  <input
                    type="text"
                    name="txtYubin"
                    class="form-control form-control-sm"
                    maxlength="8"
                    v-model="delegate.c_client_zip"
                  />
                  <div
                    v-if="errors?.path === 'clientZip'"
                    class="error-message4vali"
                  >
                    {{ errors.message }}
                  </div>
                </div>
              </div>
              <!-------------------->
              <div class="row">
                <div class="col-md-1 contTitle">住所1</div>
                <div class="col-md-5 contCnt">
                  <input
                    type="text"
                    name="txtAdd1"
                    class="form-control form-control-sm"
                    maxlength="200"
                    v-model="delegate.c_client_address_1"
                  />
                  <div
                    v-if="errors?.path === 'clientAddress_1'"
                    class="error-message4vali"
                  >
                    {{ errors.message }}
                  </div>
                </div>
              </div>
              <!-------------------->
              <div class="row">
                <div class="col-md-1 contTitle">住所2</div>
                <div class="col-md-5 contCnt">
                  <input
                    type="text"
                    name="txtAdd2"
                    class="form-control form-control-sm"
                    maxlength="200"
                    v-model="delegate.c_client_address_2"
                  />
                </div>
              </div>
              <!-------------------->
              <div class="row">
                <div class="col-md-1 contTitle">請求書送付先住所</div>
                <div class="col-md-5 contCnt">
                  <vSelect
                    :options="op4ClaimAdd"
                    v-model="delegate.c_client_flag_claim_addon"
                    :reduce="(label:any) => label.code"
                  ></vSelect>
                </div>
              </div>
              <!-------------------->
              <div class="row">
                <div class="col-md-1 contTitle">請求書送付先郵便番号</div>
                <div class="col-md-5 contCnt">
                  <input
                    type="text"
                    name="txtClaimAddYubin"
                    class="form-control form-control-sm"
                    maxlength="8"
                    v-model="delegate.c_client_claim_zip"
                  />
                </div>
              </div>
              <!-------------------->
              <div class="row">
                <div class="col-md-1 contTitle">請求書送付先住所1</div>
                <div class="col-md-5 contCnt">
                  <input
                    type="text"
                    name="txtClaimAdd1"
                    class="form-control form-control-sm"
                    maxlength="200"
                    v-model="delegate.c_client_claim_address_1"
                  />
                </div>
              </div>
              <!-------------------->
              <div class="row">
                <div class="col-md-1 contTitle">請求書送付先住所2</div>
                <div class="col-md-5 contCnt">
                  <input
                    type="text"
                    name="txtClaimAdd2"
                    class="form-control form-control-sm"
                    maxlength="200"
                    v-model="delegate.c_client_claim_address_2"
                  />
                </div>
              </div>
              <!-------------------->
              <div class="row">
                <div class="col-md-1 contTitle">支払サイト</div>
                <div class="col-md-5 contCnt selectedClear">
                  <input
                    type="text"
                    name="txtPaymentSite"
                    class="form-control form-control-sm"
                    maxlength="200"
                    v-model="delegate.c_client_paysite"
                  />
                  <!-- <vSelect
                    :options="op4PaymentSite"
                    v-model="delegate.c_client_paysite"
                    :reduce="(label:any) => label.code"
                  ></vSelect> -->
                </div>
              </div>
              <!-------------------->
              <div class="row">
                <div class="col-md-1 contTitle">顧客担当者</div>
                <div class="col-md-5 contCnt">
                  <input
                    type="text"
                    name="txtUserNm"
                    class="form-control form-control-sm"
                    maxlength="50"
                    v-model="delegate.c_client_staff_name"
                  />
                </div>
              </div>
              <!-------------------->
              <div class="row">
                <div class="col-md-1 contTitle">顧客担当者ふりがな</div>
                <div class="col-md-5 contCnt">
                  <input
                    type="text"
                    name="txtUserFurigana"
                    class="form-control form-control-sm"
                    maxlength="50"
                    v-model="delegate.c_client_staff_name_pt"
                  />
                </div>
              </div>
              <!-------------------->
              <div class="row">
                <div class="col-md-1 contTitle">顧客部署</div>
                <div class="col-md-5 contCnt">
                  <input
                    type="text"
                    name="txtBusyo"
                    class="form-control form-control-sm"
                    maxlength="50"
                    v-model="delegate.c_client_depart"
                  />
                </div>
              </div>
              <!-------------------->
              <div class="row">
                <div class="col-md-1 contTitle">役職</div>
                <div class="col-md-5 contCnt">
                  <input
                    type="text"
                    name="txtYakusyoku"
                    class="form-control form-control-sm"
                    maxlength="50"
                    v-model="delegate.c_client_post"
                  />
                </div>
              </div>
              <!-------------------->
              <div class="row">
                <div class="col-md-1 contTitle">メールアドレス</div>
                <div class="col-md-5 contCnt">
                  <input
                    type="text"
                    name="txtMail"
                    class="form-control form-control-sm"
                    maxlength="50"
                    v-model="delegate.c_client_main_mail"
                  />
                </div>
              </div>
              <div class="row">
                <div class="col-md-1 contTitle">サブメールアドレス１</div>
                <div class="col-md-5 contCnt">
                  <input
                    type="text"
                    name="txtSubMail1"
                    class="form-control form-control-sm"
                    maxlength="50"
                    v-model="delegate.c_client_sub_mail1"
                  />
                </div>
              </div>
              <div class="row">
                <div class="col-md-1 contTitle">サブメールアドレス２</div>
                <div class="col-md-5 contCnt">
                  <input
                    type="text"
                    name="txtSubMail2"
                    class="form-control form-control-sm"
                    maxlength="50"
                    v-model="delegate.c_client_sub_mail2"
                  />
                </div>
              </div>
              <div class="row">
                <div class="col-md-1 contTitle">サブメールアドレス３</div>
                <div class="col-md-5 contCnt">
                  <input
                    type="text"
                    name="txtSubMail3"
                    class="form-control form-control-sm"
                    maxlength="50"
                    v-model="delegate.c_client_sub_mail3"
                  />
                </div>
              </div>
              <!-------------------->
              <div class="row">
                <div class="col-md-1 contTitle">備考</div>
                <div class="col-md-5 contCnt">
                  <textarea
                    rows="5"
                    name="txtBiko"
                    class="form-control heightup"
                    v-model="domRemarks"
                  ></textarea>
                </div>
              </div>
              <!-------------------->
              <div class="row">
                <div class="col-md-1 contTitle">コメント</div>
                <div class="col-md-5 contCnt">
                  <textarea
                    rows="5"
                    name="txtComment"
                    class="form-control heightup"
                    v-model="domcomment"
                  ></textarea>
                </div>
              </div>
              <!-------------------->
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 成功通知モーダル -->
    <Mo_modal_alert ref="Mo_modal_success" @modalclosed="get()">
      <template v-slot:title>
        <i class="fal fa-check-circle text-success mr-2"></i>
        <span class="text-success fw-500">{{ message4ModalSuccess }}</span>
      </template>
      <template v-slot:body><br /></template>
      <template v-slot:footer>
        <div class="modal-footer"><br /></div>
      </template>
    </Mo_modal_alert>
    <!-- 成功通知モーダル -->
    <!-- 削除確認モーダル -->
    <Mo_modal_alert ref="Mo_modal_deleteConf">
      <template v-slot:title>
        <i class="fal fa-times-circle text-danger mr-2"></i
        >{{ message4ModalDelConf }}
      </template>
      <template v-slot:body><br /></template>
      <template v-slot:footer>
        <div class="modal-footer">
          <button
            @click="del()"
            type="button"
            class="btn btn-danger shadow-0 bootbox-accept"
          >
            はい</button
          ><button
            @click="closeModal4deleteConf()"
            type="button"
            class="btn btn-default bootbox-cancel"
          >
            いいえ
          </button>
        </div>
      </template>
    </Mo_modal_alert>
    <!-- 削除確認モーダル -->
    <!-- エラー確認モーダル -->
    <Mo_modal_alert ref="Mo_modal_errorConf">
      <template v-slot:title>
        <i class="fal fa-times-circle text-danger mr-2"></i
        >{{ message4ModalErrorConf }}
      </template>
      <template v-slot:body><br /></template>
      <template v-slot:footer>
        <div class="modal-footer">
          <button
            @click="closeModal4ErrorConf()"
            type="button"
            class="btn btn-default bootbox-cancel"
          >
            確認
          </button>
        </div>
      </template>
    </Mo_modal_alert>
    <!-- エラー確認モーダル -->
  </main>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import { Cl_common } from "@/functions/Cl_common";
// import { Cl_client } from "@/functions/Cl_client";
// import { DtoClientsGetReqImple } from "mediadept-common/src/common/dto/DtoClientsGetReqImple";
import { DtoClientsGetResImple } from "furukawa-common/src/common/dto/DtoClientsGetResImple";
// import { DtoClientsPutReq } from "mediadept-common/src/common/dto/abst/DtoClientsPutReq";
// import { DtoClientsPutRes } from "mediadept-common/src/common/dto/abst/DtoClientsPutRes";
import Mo_modal_alert from "@/components/molecules/Mo_modal_alert.vue";
import { Cl_client } from "@/functions/Cl_client";
import { DtoClientsPostReq } from "furukawa-common/src/common/dto/abst/DtoClientsPostReq";
import { DtoClientsPutReq } from "furukawa-common/src/common/dto/abst/DtoClientsPutReq";
import { DtoClientsGetReqImple } from "furukawa-common/src/common/dto/DtoClientsGetReqImple";
import {
  CONST_OP_COMPANY,
  CONST_OP_CLAIM_ADD,
  CONST_OP_4SIGNAGE_POSI,
  CONST_REPLACEMENT_MAP,
  CONST_ZIPCODE_FORMAT,
  // CONST_OP_PAYMENTSITE,
} from "furukawa-common/src/common/constant/Constants";
import { DtoMastersGetRes } from "furukawa-common/src/common/dto/DtoMastersGetRes";
import { DtoMastersgetReq } from "furukawa-common/src/common/dto/DtoMastersGetReq";
import { Cl_master } from "@/functions/Cl_master";
import { Cl_Authorization_menu } from "@/constants/Cl_Authorization_menu";
// import { DtoClientsPostReq } from "mediadept-common/src/common/dto/abst/DtoClientsPostReq";
// import { DtoClientsPostRes } from "mediadept-common/src/common/dto/abst/DtoClientsPostRes";

// import { CONST_OP_PAYMENTSITE } from "mediadept-common/src/common/constant/Constants";

// バリデーション
import * as Yup from "yup";

@Options({
  components: {
    vSelect,
    Mo_modal_alert,
  },
})
export default class SalesDestinationEdit extends Vue {
  //----------------------
  //バリデーション
  //----------------------
  //スキーマ宣言
  schema = Yup.object().shape({
    clientName: Yup.string().required("売上先名を入力してください"),
    clientNamePt: Yup.string().required("ふりがなを入力してください"),
    clientZip: Yup.string()
      .matches(CONST_ZIPCODE_FORMAT, "郵便番号の入力が正しくありません")
      .required("郵便番号を入力してください"),
    clientAddress_1: Yup.string().required("住所1を入力してください"),
    branchId: Yup.string().required("管轄拠点を選択してください"),
    clientClaimZip: Yup.string()
      .matches(
        CONST_ZIPCODE_FORMAT,
        "請求書送付先郵便番号の入力が正しくありません"
      )
      .nullable()
      .notRequired()
      .transform((value, originalValue) =>
        originalValue === "" ? null : value
      ),
    mailMail: Yup.string()
      .nullable()
      .email("メールアドレスの入力が正しくありません"),
    subMail1: Yup.string()
      .nullable()
      .email("サブメールアドレス１の入力が正しくありません"),
    subMail2: Yup.string()
      .nullable()
      .email("サブメールアドレス２の入力が正しくありません"),
    subMail3: Yup.string()
      .nullable()
      .email("サブメールアドレス３の入力が正しくありません"),
  });

  //エラー格納用
  errors: Yup.ValidationError | null = null;

  //----------------------
  //DOM連携用プロパティ
  //----------------------
  delegate = new DtoClientsGetResImple();
  delegate4list = new DtoMastersGetRes();
  showFlags = new Cl_Authorization_menu();
  btnDisable = false;
  isEditMode = true;

  domRemarks = "";
  domcomment = "";

  //----------------------
  //セレクトボックス用プロパティ
  //----------------------
  op4CompanyType = CONST_OP_COMPANY;
  op4SignagePosi = CONST_OP_4SIGNAGE_POSI;
  op4ClaimAdd = CONST_OP_CLAIM_ADD;

  // op4PaymentSite = CONST_OP_PAYMENTSITE;

  //----------------------
  //モーダル用プロパティ
  //----------------------
  message4ModalSuccess = "";
  message4ModalDelConf = "";
  message4ModalErrorConf = "";

  //----------------------
  //制御用メソッド
  //----------------------
  async mounted() {
    await this.get();
    await this.getMastersList();
    //設定された権限からメニューの表示非表示を制御
    this.showFlags.getAuthorization(this.$store);
  }

  //----------------------
  //基本操作用メソッド
  //----------------------
  /**
   *Masters取得用
   */
  async getMastersList() {
    //ボタン無効＋ローダー表示
    //-----------------
    this.btnDisable = true;
    const panel = document.getElementsByClassName("panel-container");
    Array.from(panel).map((element: Element) => {
      element.classList.add("enable-loader");
    });

    try {
      //処理
      //-----------------
      Cl_common.logger("処理実行社員マスタ取得");

      //準備
      //-------
      let dtoMaster = new DtoMastersgetReq();

      // dtoMaster.getStaff = 1;
      // dtoMaster.delFlag4staff = 0;

      dtoMaster.getBranch = 1;
      dtoMaster.delFlag4Branch = 0;

      // dtoMaster.getClients = 1;
      // dtoMaster.delFlag4clients = 0;

      // dtoMaster.getSuppliers = 1;
      // dtoMaster.delFlag4suppliers = 0;

      //API実行
      //-------
      this.delegate4list = await Cl_master.get(dtoMaster);
      console.log("this.delegate4list");
      console.log(this.delegate4list);

      //レスポンス処理
      //-------
    } catch (error) {
      //モーダルのメッセージを設定
      this.message4ModalErrorConf = "エラーが発生しました"; //モーダル表示
      const modal: any = this.$refs.Mo_modal_errorConf;
      modal.showModal();

      this.delegate4list = new DtoMastersGetRes();
      Cl_common.logger(error);
    } finally {
      //ボタン無効解除＋ローダー非表示
      //-----------------
      this.btnDisable = false;
      Array.from(panel).map((element: Element) => {
        element.classList.remove("enable-loader");
      });
    }
  }
  /**
   * データを読み込む
   */
  async get() {
    //ボタン無効＋ローダー表示
    //-----------------
    this.btnDisable = true;
    const panel = document.getElementsByClassName("panel-container");
    Array.from(panel).map((element: Element) => {
      element.classList.add("enable-loader");
    });

    try {
      //処理
      //-----------------
      Cl_common.logger("処理実行");

      //パラメータにIDが指定されていなければ、新規追加モードでデータを読み込まない
      //-------
      let id = Cl_common.getParam("id");
      if (id == "") {
        //新規追加
        this.isEditMode = false;
        //初期値設定
        this.delegate.c_client_company_type = 1;
        this.delegate.c_client_flag_company_signage_posi = 1;
        return;
      } else {
        //編集
        this.isEditMode = true;
      }

      //準備
      //-------
      let dto = new DtoClientsGetReqImple();

      dto.c_client_id = Number(id);

      //API実行
      //-------
      this.delegate = await Cl_client.get(dto);
      //レスポンス処理
      //-------
      this.domRemarks = this.delegate.c_client_remarks!;

      this.domcomment = this.delegate.c_client_comment!;

      //IDがnullなら一覧へ遷移
      if (this.delegate.c_client_id == null) {
        this.$router.push("/salesDestinationList");
      }
    } catch (error) {
      //モーダルのメッセージを設定
      this.message4ModalErrorConf = "エラーが発生しました";
      //モーダル表示
      const modal: any = this.$refs.Mo_modal_errorConf;
      modal.showModal();

      Cl_common.logger(error);
    } finally {
      //ボタン無効解除＋ローダー非表示
      //-----------------
      this.btnDisable = false;
      Array.from(panel).map((element: Element) => {
        element.classList.remove("enable-loader");
      });
    }
  }
  /**
   * データを更新する
   */
  async upd(isDel: boolean) {
    //ボタン無効＋ローダー表示
    //-----------------
    this.btnDisable = true;
    const panel = document.getElementsByClassName("panel-container");
    Array.from(panel).map((element: Element) => {
      element.classList.add("enable-loader");
    });

    try {
      //処理
      //-----------------
      Cl_common.logger("処理実行");

      //準備
      //-------
      let dto = new DtoClientsPutReq();
      if (isDel) {
        //削除処理：削除フラグを立てる。
        dto.c_client_id = this.delegate.c_client_id;
        dto.c_client_flag_del = 1;
      } else {
        //バリデーション
        //-----------------
        this.errors = null;
        this.schema.validateSync({
          clientName: this.delegate.c_client_name,
          clientNamePt: this.delegate.c_client_name_pt,
          clientZip: this.delegate.c_client_zip,
          clientAddress_1: this.delegate.c_client_address_1,
          branchId: this.delegate.c_branch_id,
          clientClaimZip: this.delegate.c_client_claim_zip,
          mailMail: this.delegate.c_client_main_mail,
          subMail1: this.delegate.c_client_sub_mail1,
          subMail2: this.delegate.c_client_sub_mail2,
          subMail3: this.delegate.c_client_sub_mail3,
        });

        //更新処理：delegateからdtoにデータ投入。
        dto = Object.assign(new DtoClientsPutReq(), this.delegate);
        //備考欄を戻す
        if (this.domRemarks != null) {
          dto.c_client_remarks = this.domRemarks;
        }
        //コメントを戻す
        if (this.domcomment != null) {
          dto.c_client_comment = this.domcomment;
        }
        //売上先名に変換すべき全角文字があれば半角に直す
        if (this.delegate.c_client_name != null) {
          dto.c_client_name = this.replaceCharacters(
            this.delegate.c_client_name
          );
        }

        if (this.delegate.c_client_name2 != null) {
          dto.c_client_name2 = this.replaceCharacters(
            this.delegate.c_client_name2
          );
        }

        if (this.delegate.c_client_name3 != null) {
          dto.c_client_name3 = this.replaceCharacters(
            this.delegate.c_client_name3
          );
        }
      }

      //API実行
      //-------
      await Cl_client.put(dto);
      //レスポンスの処理
      //-------

      //更新処理：
      //モーダルのメッセージを設定
      if (isDel) {
        //削除処理：
        this.message4ModalSuccess = "正常に削除されました";
      } else {
        //更新処理：
        this.message4ModalSuccess = "正常に変更されました";
      }

      //モーダルを表示
      const modal: any = this.$refs.Mo_modal_success;
      modal.showModal();
    } catch (error) {
      if (error instanceof Yup.ValidationError) {
        //バリデーション
        //---------------
        //モーダルのメッセージを設定
        this.message4ModalErrorConf = error.errors[0];
        this.errors = error;
      } else {
        //それ以外
        //---------------
        //モーダルのメッセージを設定
        this.message4ModalErrorConf = "エラーが発生しました";
      }
      //モーダル表示
      const modal: any = this.$refs.Mo_modal_errorConf;
      modal.showModal();

      Cl_common.logger(error);
    } finally {
      //ボタン無効解除＋ローダー非表示
      //-----------------
      this.btnDisable = false;
      Array.from(panel).map((element: Element) => {
        element.classList.remove("enable-loader");
      });
    }
  }

  /**
   * データを新たに登録する
   */
  async add() {
    //ボタン無効＋ローダー表示
    //-----------------
    this.btnDisable = true;
    const panel = document.getElementsByClassName("panel-container");
    Array.from(panel).map((element: Element) => {
      element.classList.add("enable-loader");
    });

    try {
      //処理
      //-----------------
      Cl_common.logger("処理実行");

      //バリデーション
      //-----------------
      this.errors = null;
      this.schema.validateSync({
        clientName: this.delegate.c_client_name,
        clientNamePt: this.delegate.c_client_name_pt,
        clientZip: this.delegate.c_client_zip,
        clientAddress_1: this.delegate.c_client_address_1,
        branchId: this.delegate.c_branch_id,
        clientClaimZip: this.delegate.c_client_claim_zip,
        mailMail: this.delegate.c_client_main_mail,
        subMail1: this.delegate.c_client_sub_mail1,
        subMail2: this.delegate.c_client_sub_mail2,
        subMail3: this.delegate.c_client_sub_mail3,
      });

      //準備
      //-------
      //備考欄を戻す
      if (this.domRemarks != null) {
        this.delegate.c_client_remarks = this.domRemarks;
      }
      //コメントを戻す
      if (this.domcomment != null) {
        this.delegate.c_client_comment = this.domcomment;
      }

      //売上先名に変換すべき全角文字があれば半角に直す
      if (this.delegate.c_client_name != null) {
        this.delegate.c_client_name = this.replaceCharacters(
          this.delegate.c_client_name
        );
      }

      if (this.delegate.c_client_name2 != null) {
        this.delegate.c_client_name2 = this.replaceCharacters(
          this.delegate.c_client_name2
        );
      }

      if (this.delegate.c_client_name3 != null) {
        this.delegate.c_client_name3 = this.replaceCharacters(
          this.delegate.c_client_name3
        );
      }

      let dto = Object.assign(new DtoClientsPostReq(), this.delegate);
      dto.c_client_flag_del = 0;

      //API実行
      //-------
      const res = await Cl_client.post(dto);

      //レスポンスの処理
      //-------
      //編集画面のURL作成
      this.$router.push({
        path: "/salesDestinationEdit",
        query: { id: res.c_client_id },
      });

      //モーダルのメッセージを設定
      this.message4ModalSuccess = "正常に追加されました";

      //モーダルを表示
      const modal: any = this.$refs.Mo_modal_success;
      modal.showModal();
    } catch (error) {
      if (error instanceof Yup.ValidationError) {
        //バリデーション
        //---------------
        //モーダルのメッセージを設定
        this.message4ModalErrorConf = error.errors[0];
        this.errors = error;
      } else {
        //それ以外
        //---------------
        //モーダルのメッセージを設定
        this.message4ModalErrorConf = "エラーが発生しました";
      }
      //モーダル表示
      const modal: any = this.$refs.Mo_modal_errorConf;
      modal.showModal();

      Cl_common.logger(error);
    } finally {
      //ボタン無効解除＋ローダー非表示
      //-----------------
      this.btnDisable = false;
      Array.from(panel).map((element: Element) => {
        element.classList.remove("enable-loader");
      });
    }
  }

  /**
   * データ削除用のモーダルを表示
   */
  async delConf() {
    //モーダルのメッセージを設定
    this.message4ModalDelConf =
      "【" +
      this.delegate.c_client_id +
      "】" +
      this.delegate.c_client_name +
      "を削除します。よろしいですか？";
    //モーダル表示
    const modal: any = this.$refs.Mo_modal_deleteConf;
    modal.showModal();
  }
  /**
   * データを削除する
   */
  async del() {
    //削除フラグのあるテーブルなので更新処理。
    this.closeModal4deleteConf();
    this.upd(true);
  }

  /**
   * チェックボックスの値を数値に変換する
   * @param event
   */
  cnvCb(event: any): number {
    if (event.target.checked) {
      return 1;
    } else {
      return 0;
    }
  }

  /**
   * 全角アルファベット、スペース、@、&、を半角に置き換える
   * @param input
   */
  replaceCharacters(input: string): string {
    return input
      .split("")
      .map((char) => CONST_REPLACEMENT_MAP[char] || char)
      .join("");
  }

  //----------------------
  //モーダル用メソッド
  //----------------------
  async closeModal4deleteConf(): Promise<void> {
    const modal: any = this.$refs.Mo_modal_deleteConf;
    modal.closeModal();
  }
  async closeModal4ErrorConf(): Promise<void> {
    const modal: any = this.$refs.Mo_modal_errorConf;
    modal.closeModal();
  }
}
</script>
<style scoped>
.heightup {
  /* width: 95%; */
  /* height: 300px; */
}
</style>
